import $ from "jquery";

class Filters {

    constructor() {
        this.handleClick();
    }

    handleClick() {
        $(document).ready(() => {
            $('.filters__item-header').click((event) => {
               const item = $(event.currentTarget);

               item.parent().toggleClass("filters__item--expanded");
               item.parent().find(".filters__item-content").slideToggle();
            });

            if ($(window).width() <= 768) {
                const item = $('#filters__categories');

                item.toggleClass("filters__item--expanded");
                item.find(".filters__item-content").slideToggle();
            }
        });
    }

}

export default new Filters();
